import { render, staticRenderFns } from "./AppIconTarget.vue?vue&type=template&id=72d0e12f&scoped=true&"
import script from "./AppIconTarget.vue?vue&type=script&lang=js&"
export * from "./AppIconTarget.vue?vue&type=script&lang=js&"
import style0 from "./AppIconTarget.vue?vue&type=style&index=0&id=72d0e12f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d0e12f",
  null
  
)

export default component.exports